/**
 * Delete Task Template API
 * Feature: Generic Configurable Task System
 * Branch: 022-i-like-all
 */

import axiosInstance from '@/api/axiosInstance';

export async function deleteTaskTemplate(id: string): Promise<void> {
  await axiosInstance.delete(`/api/task-templates/${id}`);
}